import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { sanitizeInfoHTML } from '../../shared/utils';
import '../../components/InfoTab.css'; /* .info-content styles for rendered HTML */
import ShareTabFeatureMessage from './ShareTabFeatureMessage';

const InfoTabShare = ({ parsedData, onCopyItineraryClick }) => {
  const { t } = useTranslation();
  const infoSections = parsedData?.infoSections || [];

  if (infoSections.length === 0) {
    return <ShareTabFeatureMessage feature="info" icon="bi-info-circle" onCopyItineraryClick={onCopyItineraryClick} />;
  }

  return (
    <div className="info-tab-share">
      <Row>
        <Col>
          <h4 className="mb-4">{t('planDetail.info.tripInformation')}</h4>
          {infoSections.map((section, index) => (
            <Card key={section.id || index} className="mb-4">
              <Card.Header className="bg-light">
                <h5 className="mb-0">
                  <i className="bi bi-info-circle me-2 text-primary"></i>
                  {section.title}
                </h5>
              </Card.Header>
              <Card.Body>
                <div 
                  className="info-content"
                  dangerouslySetInnerHTML={{ 
                    __html: sanitizeInfoHTML(section.content || t('planDetail.info.noContentAvailable'))
                  }}
                />
              </Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default InfoTabShare;
